module.exports = __webpack_public_path__ + "static/img/img_4.a3b220d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/children_gallery/img_4.jpg
// module id = uajm
// module chunks = 0